<template>
  <div>
    <!-- page-wrapper Start-->
    <div class="container-fluid p-0">
      <div class="row m-0">
        <div class="col-12 p-0">
          <div class="login-card">
            <div>
              <div>
                <a class="logo">
                  <!--<img :src="ImageEndpoint + CompanyLogo" class="img-fluid for-light" v-if="CompanyLogo" style='height: 50px;'>
                  	<img src="@/assets/images/logo.png" class="img-fluid for-light" v-if="!CompanyLogo" style='height: 50px;'>-->
                  <img
                    src="@/assets/images/logo.png"
                    class="img-fluid for-light"
                    style="height: 50px"
                  />
                </a>
              </div>
              <div class="login-main">
                <b-card no-body>
                  <b-tabs pills vertical>
                    <b-tab active>
                      <b-card-text>
                        <form class="theme-form">
                          <h4>Sign in to account</h4>
                          <p>Enter your email & password to login</p>
                          <div class="form-group">
                            <label class="col-form-label">Email Address</label>
                            <input
                              v-model="email"
                              class="form-control"
                              type="email"
                              required=""
                              :class="{
                                'is-invalid': submitted && !email,
                              }"
                            />
                            <div
                              v-show="submitted && !email"
                              class="invalid-feedback"
                            >
                              Email is required
                            </div>
                          </div>
                          <div class="form-group">
                            <label class="col-form-label">Password</label>
                            <input
                              v-model="password"
                              autocomplete=""
                              class="form-control"
                              :type="type"
                              name="login[password]"
                              required=""
                              :class="{
                                'is-invalid': submitted && !email,
                              }"
                            />
                            <div
                              v-show="submitted && !password"
                              class="invalid-feedback"
                            >
                              Email is required
                            </div>
                            <div class="show-hide" @click="showPassword">
                              <span class="show"></span>
                            </div>
                          </div>
                          <div class="form-group mb-0">
                            <div class="checkbox p-0">
                              <input id="checkbox1" type="checkbox" />
                              <label class="text-muted" for="checkbox1"
                                >Remember password</label
                              >
                            </div>
                            <button
                              class="btn btn-primary btn-block"
                              type="button"
                              @click="UserLogin"
                            >
                              Login
                            </button>
                          </div>
                        </form>
                      </b-card-text>
                    </b-tab>
                  </b-tabs>
                </b-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- latest jquery-->
  </div>
</template>

<script>
  import firebase from "firebase";
  import Userauth from "../auth/js/index";
  import Endpoints from "@/config/ApiEndpoints.js";
  import Swal from "sweetalert2";

  export default {
    name: "login",
    data() {
      return {
        CompanyLogo: "",
        ImageEndpoint: Endpoints.Helper.Image + "/",
        type: "password",
        email: "",
        password: "",
        username: "",
        passwordjwt: "",
        submitted: false,
      };
    },
    computed: {
      // JWT authentication
      loggingIn() {
        return this.$store.state.authentication.status.loggingIn;
      },
    },
    created() {
      // reset login status for JWT
      this.$store.dispatch("authentication/logout");
    },
    mounted() {
      var Company = JSON.parse(localStorage.getItem("Company"));
      if (Company && Company.logo) {
        this.CompanyLogo = Company.logo;
      }
    },
    methods: {
      showPassword: function () {
        if (this.type === "password") {
          this.type = "text";
        } else {
          this.type = "password";
        }
      },
      UserLogin: function () {
        this.submitted = true;
        if (this.email != "" && this.password != "") {
          var obj = { email: this.email, password: this.password };
          Swal.fire({
            title: "Checking...",
            text: "Please wait...",
            imageUrl: require("../assets/images/LoadingTwo.gif"),
            showConfirmButton: false,
            allowOutsideClick: false,
          });
          axios
            .post(Endpoints.User.Login, obj)
            .then((Response) => {
              Swal.close();
              if (Response.data.success === true) {
                localStorage.setItem("token", Response.data.token);
                localStorage.setItem(
                  "User",
                  JSON.stringify(Response.data.User)
                );
                localStorage.setItem(
                  "Company",
                  JSON.stringify(Response.data.Company)
                );
                localStorage.setItem(
                  "FleetSubscription",
                  JSON.stringify(Response.data.FleetSubscription)
                );

                // Update the value
                localStorage.setItem(
                  "AccountPermissions",
                  JSON.stringify(Response.data.AccountPermissions)
                );
                // Update the value
                localStorage.setItem(
                  "permissions",
                  JSON.stringify(Response.data.permissions)
                );
                window.pbx_SiteTitle = Response.data.Company.name;
                Userauth.localLogin(Response.data);
                this.$router.replace("/");
                //this.$router.push('/home');
                if (localStorage.getItem("Classes")) {
                  localStorage.removeItem("Classes");
                }
              } else {
                this.$toasted.show(Response.data.message, {
                  theme: "bubble",
                  position: "top-center",
                  type: "error",
                  duration: 2000,
                });
              }
            })
            .catch((error) => {
              this.$toasted.show(error, {
                theme: "bubble",
                position: "top-center",
                type: "error",
                duration: 2000,
              });
            });
        } else {
          this.$toasted.show("Please enter email and password", {
            theme: "bubble",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
        }
      },
    },
  };
</script>
